// extracted by mini-css-extract-plugin
module.exports = {"popover-wrapper":"Popover_popover-wrapper__xZrLI","popover-body":"Popover_popover-body__D2Plf"};